export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6542.ef319f6e.jpg";